<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__code">404</span>
      <h1>ページが見つかりません</h1>
      <p>
        URLが変更されたか、ページが削除された可能性があります。
        ダッシュボードまたはログイン画面から再度お試しください。
      </p>
      <div class="preika-error-panel__actions">
        <router-link to="/dashboard" class="btn btn-primary">
          ダッシュボードへ
          <CIcon name="cil-arrow-right"/>
        </router-link>
        <router-link :to="{ name: 'Login' }" class="btn btn-secondary">
          ログイン画面へ
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'Page404',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  },
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 620px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 28px;
  object-fit: contain;
}

.preika-error-panel__code {
  display: block;
  margin-bottom: 4px;
  color: var(--preika-blue-600);
  font-size: 64px;
  font-weight: 800;
  letter-spacing: -.03em;
  line-height: 1;
}

.preika-error-panel h1 {
  margin: 13px 0 12px;
  color: var(--preika-navy-900);
  font-size: 24px;
}

.preika-error-panel p {
  max-width: 460px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }

  .preika-error-panel__code {
    font-size: 52px;
  }

  .preika-error-panel__actions {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
